/**
 * Triggers a browser download for an in-memory blob.
 *
 * The object URL is revoked straight after the synthetic click: the browser has
 * already taken its own reference by then, so nothing is held for the session.
 *
 * @param blob - The file contents.
 * @param filename - Name offered to the user in the save dialog.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
